import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

type RSelectableCardProps = React.HTMLAttributes<HTMLDivElement>;

export function RSelectableCard({ children, ...rest }: RSelectableCardProps) {
    return <Card {...rest}>{children}</Card>;
}

const Card = styled('div')({
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 12,
    padding: '20px',
    cursor: 'pointer',
    transition: 'box-shadow 0.2s ease',
    height: '100%',
    boxSizing: 'border-box',
    '&:hover': {
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
        borderColor: Colors.mediumTurq,
    },
});
